import type { VisualizationData } from '../../types';
import { BarChart } from './BarChart';
import { LineChart } from './LineChart';
import { PieChart } from './PieChart';
import { DataTable } from './DataTable';
import { SummaryCard } from './SummaryCard';

interface VisualizationProps {
  data: VisualizationData;
  animated?: boolean;
}

export function Visualization({ data, animated }: VisualizationProps) {
  const { type } = data.config;

  if (!data.data || data.data.length === 0) {
    return (
      <div className="rounded-lg border border-border bg-muted/30 p-4 text-center text-sm text-muted-foreground">
        No data available for visualization
      </div>
    );
  }

  switch (type) {
    case 'bar_chart':
      return <BarChart data={data} animated={animated} />;
    case 'line_chart':
      return <LineChart data={data} animated={animated} />;
    case 'pie_chart':
      return <PieChart data={data} animated={animated} />;
    case 'table':
      return <DataTable data={data} />;
    case 'summary_card':
      return <SummaryCard data={data} />;
    default:
      return <DataTable data={data} />;
  }
}
